export const setUpAnchorLink = () => {
  const anchorLinkList = document.querySelectorAll('.js-anchor-link');

  anchorLinkList.forEach((anchorLink) => {
    anchorLink.addEventListener('click', (event) => {
      event.preventDefault();

      const data = event.currentTarget.dataset.scroll;
      const scrollTarget = document.getElementById(data);

      scrollTarget.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    });
  });
};
